<template>
  <AddFamilyTemplate :header="header">
    <template #content>
      <v-layout
        justify-center
        class="pt-4"
      >
        <v-flex
          xs10
          sm8
        >
          <p class="required-block required-block_left mb-2">
            {{ $t('label.required_fields') }}
          </p>
          <h2 class="display-3 display-3_dark mb-1">
            {{ $t('add_family.title') }}
          </h2>
          <p class="required-block f-1">
            {{ $t('add_family.subtitle') }}
          </p>
          <v-select
            v-if="getOnlyVisibleSourceCategories?.length > 0"
            v-model="category"
            v-validate="validationRules.get('category')"
            class="required-field"
            :items="getOnlyVisibleSourceCategories"
            item-text="name"
            item-value="source_category_id"
            :label="$t('label.category')"
            :error-messages="errors.collect('category')"
            data-vv-name="category"
            :data-vv-as="$t('label.category')"
            required
            append-icon="expand_more"
          />
          <v-progress-linear
            v-else
            height="5"
            color="sz_violet"
            indeterminate
          />
          <div v-if="showFields">
            <v-text-field
              v-model="name"
              v-validate="validationRules.get('regular_field')"
              :error-messages="errors.collect('regular_field')"
              data-vv-name="regular_field"
              :label="$t('label.custom_option_label')"
              :data-vv-as="$t('label.custom_option_label')"
            />
            <p class="mb-0">
              {{ $t('helps.help_phone') }}
            </p>
            <v-text-field
              v-model="phone_number"
              v-validate="validationRules.get('non_required_phone')"
              :mask="phoneMask(phone_number)"
              name="phone"
              data-vv-name="phone"
              :error-messages="errors.collect('phone')"
              :data-vv-as="$t('label.phone')"
              type="tel"
              inputmode="tel"
            />
          </div>
        </v-flex>
      </v-layout>
    </template>
    <template #actions>
      <v-layout
        align-center
        justify-end
        wrap
        :justify-center="$vuetify.breakpoint.xs"
      >
        <v-flex
          shrink
          :mr-4="$vuetify.breakpoint.smAndUp"
          order-xs2
          order-sm1
          :mt-2="$vuetify.breakpoint.xs"
        >
          <a
            class="link_iconed"
            @click="prevStep()"
          >
            <v-icon>chevron_left</v-icon>{{ $t('buttons.prev_button') }}
          </a>
        </v-flex>
        <v-flex
          shrink
          order-xs1
          order-sm2
        >
          <v-btn
            color="sz_violet"
            class=""
            @click="nextStep()"
          >
            {{ $t('buttons.next_button') }}
          </v-btn>
        </v-flex>
      </v-layout>
    </template>
  </AddFamilyTemplate>
</template>

<script>
import AddFamilyTemplate from '@/components/addFamily/AddFamilyTemplate';
import validationRules from '@/constants/validationRules';
import phoneMask from '@/utils/phoneMask';

import scrollToTopErrorMessage from '@/mixins/scrollToTopErrorMessage';

import { mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';

const PRIVATES = [5, 14];

export default {
    name: 'FamilySource',
    components: { AddFamilyTemplate },
    mixins: [scrollToTopErrorMessage],
    data () {
        return {
            validationRules,
            phoneMask
        };
    },
    computed: {
        ...mapFields('familyData', ['source.category', 'source.name', 'source.phone_number']),
        ...mapGetters('defaultApi', ['getOnlyVisibleSourceCategories']),
        header () {
            return {
                title: this.$t('add_family.page_title'),
                subtitle: this.$t('add_family.page_subtitle')
            };
        },
        showFields () {
            return !PRIVATES.includes(this.category) && this.category != null;
        },
        showConsent () {
            return this.$store.getters['familyData/isConsentPageVisible'];
        }
    },
    created () {
        this.$store.dispatch('defaultApi/getSourceCategories');
    },
    methods: {
        prevStep () {
            if (this.showConsent) {
                this.$router.push({ name: 'family-consent' });
                return;
            }
            this.$router.push({ name: 'family-details' });
        },
        nextStep () {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.$router.push({ name: 'family-information' });
                } else {
                    this.scrollToTopErrorMessage();
                }
            });
        }
    }
};
</script>

<style scoped></style>
